import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { app_name, email, path, phone_number_1, static_img_url } from '../Variables'
import { setDefaultAll } from '../CodeEasier'
import { useNavigate } from 'react-router-dom'
import { LazyHelmet } from '../../base'

import LazyImage from './LazyImage'

function InternalError() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  function home() {
    navigate(path.home)
  }

  useEffect(() => {
    setDefaultAll(dispatch, true)
  }, [dispatch])

  return (
    <div className='handlers'>
      <LazyHelmet>
        <title>Somethin Went Wrong ~ {app_name}</title>
      </LazyHelmet>

       
      <LazyImage src={`${static_img_url}/handlers/somethingwentwrong.webp`} alt={'Image'}/>
      <div className='mt-3 h7'>Oops! Something went wrong, but our is team working on it.</div>
      <div className='mt-2 mb-2 h7'>If it continues, feel free to reach out to us at - </div>
      <div className='h7'> Call or Whatsapp - {phone_number_1} <br/> Email - {email}</div>
      <button className='primaryButton h7 mt-3' onClick={() => home()}>Go to Home</button>
    </div>
  )
}

export default InternalError